const theme = {
  "token": {
    "colorPrimary": "#ff692e",
    "colorInfo": "#ff692e",
    "components": {
      "Layout": {
        "bodyBg": "rgb(244, 246, 248)"
      }
    }
  }
};

export default theme;
